import { navigate } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexRow, { IFlexRow } from '@ui/atoms/FlexRow';

import fullWidth from '@ui/styled/FullWidth';

import { CardContent } from '@folx-types/dashboard';

import theme from '@theme/FolxTheme';

interface IProfileLinkProps extends CardContent {}

const FullWidthButton = fullWidth('button');

const FullWidthRow = styled(fullWidth<IFlexRow>(FlexRow))`
	align-items: center;
	background: ${theme.colors.white};
	cursor: pointer;
	padding: ${theme.spacing.xssm};

	svg {
		height: ${theme.spacing.smmd};
		width: ${theme.spacing.smmd};
	}

	:hover {
		background: ${theme.colors.lilacLight};
	}
`;

const ProfileLink: FC<IProfileLinkProps> = ({ header, Icon, pathName }) => {
	return (
		<FullWidthButton onClick={() => navigate(pathName)} aria-label={header} role="menuitem">
			<FullWidthRow gap="xssm">
				<Icon />
				<BasicText variant="pillText">{header}</BasicText>
			</FullWidthRow>
		</FullWidthButton>
	);
};

export default styled(ProfileLink)``;
